var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.markerArray),function(marker,index){return _c('marker-single',{key:((marker.id) + "-" + (marker.type) + "-" + index),attrs:{"marker":marker}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }